import React from 'react';
import Grid from '@material-ui/core/Grid';

function Copyright() {
  const year = new Date().getFullYear();
  return (
    <Grid
      container
      align-self="flex-end"
      direction="row"
      justifyContent="center"
      alignItems="center"
    >
      <Grid>Copyright &#169; {year} Gutenberg Certs Corp </Grid>
    </Grid>
  );
}

export default Copyright;
